import { SortDescriptor } from "react-aria-components";

import { ModuleVersionSubmoduleRow } from "./types";

export const sortModuleVersionSubmodules = (
  submodules: ModuleVersionSubmoduleRow[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return submodules;
  }

  const direction = sortDescriptor.direction === "ascending" ? 1 : -1;

  return [...submodules].sort(
    (a, b) => a.id.localeCompare(b.id, undefined, { numeric: true }) * direction
  );
};
